import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { protectedResources } from '../b2c-config';

@Injectable({
  providedIn: 'root'
})
export class ExternalAssetService { 
  public salesForceInvocationEvent = new BehaviorSubject<any>({});
  constructor(private http: HttpClient) { }
  saveExternalAsset(model){
    return this.http.post(`${protectedResources.realizerApi.endpoint}api/Device/UpsertExternalAsset`, model);
  }
  getExternalAssetDetails(deviceId){
    return this.http.get(`${protectedResources.etlApi.endpoint}api/Device/GetExternalAsset?deviceId=${deviceId}`);
  }
  public getRemoteActivityByDeviceId(deviceId) {
    return this.http.get(`${protectedResources.etlApi.endpoint}api/Device/GetRemoteActivityForExternalAssetByDeviceId?DeviceID=${deviceId}`);
  }
}
